import * as React from "react";
const SvgSimpleGreenCarTopView = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 960 476"
    {...props}
  >
    <defs>
      <linearGradient id="SimpleGreenCarTopView_svg__a">
        <stop
          offset={0}
          style={{
            stopColor: "#1a1a1a",
            stopOpacity: 1,
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: "#000",
            stopOpacity: 0,
          }}
        />
      </linearGradient>
      <linearGradient
        xlinkHref="#SimpleGreenCarTopView_svg__a"
        id="SimpleGreenCarTopView_svg__b"
        x1={871.33}
        x2={848.16}
        y1={842.3}
        y2={834.68}
        gradientTransform="translate(8.309 -2.652)"
        gradientUnits="userSpaceOnUse"
      />
      <linearGradient
        xlinkHref="#SimpleGreenCarTopView_svg__a"
        id="SimpleGreenCarTopView_svg__h"
        x1={879.9}
        x2={812.14}
        y1={537.5}
        y2={533.5}
        gradientTransform="translate(80.349 365.15)scale(.89332)"
        gradientUnits="userSpaceOnUse"
      />
      <linearGradient
        xlinkHref="#SimpleGreenCarTopView_svg__a"
        id="SimpleGreenCarTopView_svg__d"
        x1={879.9}
        x2={815.82}
        y1={537.5}
        y2={531.91}
        gradientTransform="translate(27.625 296.49)"
        gradientUnits="userSpaceOnUse"
      />
      <linearGradient
        xlinkHref="#SimpleGreenCarTopView_svg__a"
        id="SimpleGreenCarTopView_svg__k"
        x1={871.33}
        x2={848.16}
        y1={842.3}
        y2={834.68}
        gradientTransform="matrix(1 0 0 -1 8.309 1452)"
        gradientUnits="userSpaceOnUse"
      />
      <linearGradient
        xlinkHref="#SimpleGreenCarTopView_svg__a"
        id="SimpleGreenCarTopView_svg__l"
        x1={887.9}
        x2={876.14}
        y1={528.36}
        y2={528.42}
        gradientTransform="matrix(1 0 0 -1 21.438 1151.5)"
        gradientUnits="userSpaceOnUse"
      />
      <linearGradient
        xlinkHref="#SimpleGreenCarTopView_svg__a"
        id="SimpleGreenCarTopView_svg__m"
        x1={879.9}
        x2={815.82}
        y1={537.5}
        y2={531.91}
        gradientTransform="matrix(1 0 0 -1 27.625 1152.9)"
        gradientUnits="userSpaceOnUse"
      />
      <linearGradient
        xlinkHref="#SimpleGreenCarTopView_svg__a"
        id="SimpleGreenCarTopView_svg__n"
        x1={897.22}
        x2={883.76}
        y1={542.4}
        y2={535.37}
        gradientTransform="matrix(1 0 0 -1 21.438 1151.5)"
        gradientUnits="userSpaceOnUse"
      />
      <linearGradient
        xlinkHref="#SimpleGreenCarTopView_svg__a"
        id="SimpleGreenCarTopView_svg__o"
        x1={880.71}
        x2={835.99}
        y1={552.05}
        y2={501.08}
        gradientTransform="matrix(1 0 0 -1 21.438 1151.5)"
        gradientUnits="userSpaceOnUse"
      />
      <linearGradient
        xlinkHref="#SimpleGreenCarTopView_svg__a"
        id="SimpleGreenCarTopView_svg__p"
        x1={887.9}
        x2={805.29}
        y1={528.36}
        y2={529.61}
        gradientTransform="matrix(.89332 0 0 -.89332 94.156 1087.8)"
        gradientUnits="userSpaceOnUse"
      />
      <linearGradient
        xlinkHref="#SimpleGreenCarTopView_svg__a"
        id="SimpleGreenCarTopView_svg__q"
        x1={879.9}
        x2={812.14}
        y1={537.5}
        y2={533.5}
        gradientTransform="matrix(.89332 0 0 -.89332 80.349 1084.2)"
        gradientUnits="userSpaceOnUse"
      />
      <linearGradient
        xlinkHref="#SimpleGreenCarTopView_svg__a"
        id="SimpleGreenCarTopView_svg__r"
        x1={229.7}
        x2={205.59}
        y1={873.14}
        y2={867.68}
        gradientTransform="scale(1 -1)rotate(7.932 10770.938 311.695)"
        gradientUnits="userSpaceOnUse"
      />
      <linearGradient
        xlinkHref="#SimpleGreenCarTopView_svg__a"
        id="SimpleGreenCarTopView_svg__s"
        x1={238.83}
        x2={216.56}
        y1={873.06}
        y2={872.65}
        gradientTransform="scale(1 -1)rotate(7.932 10766.693 386.342)"
        gradientUnits="userSpaceOnUse"
      />
      <linearGradient
        xlinkHref="#SimpleGreenCarTopView_svg__a"
        id="SimpleGreenCarTopView_svg__c"
        x1={887.9}
        x2={876.14}
        y1={528.36}
        y2={528.42}
        gradientTransform="translate(21.438 297.91)"
        gradientUnits="userSpaceOnUse"
      />
      <linearGradient
        xlinkHref="#SimpleGreenCarTopView_svg__a"
        id="SimpleGreenCarTopView_svg__e"
        x1={897.22}
        x2={883.76}
        y1={542.4}
        y2={535.37}
        gradientTransform="translate(21.438 297.91)"
        gradientUnits="userSpaceOnUse"
      />
      <linearGradient
        xlinkHref="#SimpleGreenCarTopView_svg__a"
        id="SimpleGreenCarTopView_svg__f"
        x1={880.71}
        x2={835.99}
        y1={552.05}
        y2={501.08}
        gradientTransform="translate(21.438 297.91)"
        gradientUnits="userSpaceOnUse"
      />
      <linearGradient
        xlinkHref="#SimpleGreenCarTopView_svg__a"
        id="SimpleGreenCarTopView_svg__g"
        x1={887.9}
        x2={805.29}
        y1={528.36}
        y2={529.61}
        gradientTransform="translate(94.156 361.57)scale(.89332)"
        gradientUnits="userSpaceOnUse"
      />
      <linearGradient
        xlinkHref="#SimpleGreenCarTopView_svg__a"
        id="SimpleGreenCarTopView_svg__i"
        x1={229.7}
        x2={205.59}
        y1={873.14}
        y2={867.68}
        gradientTransform="rotate(7.932 317.412 1036.405)"
        gradientUnits="userSpaceOnUse"
      />
      <linearGradient
        xlinkHref="#SimpleGreenCarTopView_svg__a"
        id="SimpleGreenCarTopView_svg__j"
        x1={238.83}
        x2={216.56}
        y1={873.06}
        y2={872.65}
        gradientTransform="rotate(7.932 313.296 1111.043)"
        gradientUnits="userSpaceOnUse"
      />
    </defs>
    <path
      d="M610.52 493.69c-1.509.009-4.721.305-6.469.938l-3.5 1.5 8.656 35.938-124.81.28c-2.436.006-4.887-.013-7.343-.03a931.076 931.076 0 0 1-14.844-.22c-7.293-.166-14.67-.412-22.062-.718-.396-.016-.792-.046-1.188-.062-14.932-.63-30.007-1.492-45.03-2.438-20.327-1.283-40.52-2.707-60.125-3.875-14.528-.865-28.732-1.58-42.375-2-9.369-.289-18.464-.457-27.25-.406-4.316.025-8.568.093-12.719.219-4.15.125-8.38.355-12.656.656-2.138.15-4.278.31-6.437.5-6.469.568-13.045 1.321-19.594 2.187h-.031a551.944 551.944 0 0 0-13.062 1.907c-4.344.68-8.674 1.397-12.937 2.156-4.254.756-8.47 1.565-12.594 2.375-.01.002-.022-.002-.032 0-2.066.406-4.07.804-6.093 1.219a836.448 836.448 0 0 0-17.5 3.78c-.01.003-.021-.001-.031 0a895.26 895.26 0 0 0-10.72 2.5 913.018 913.018 0 0 0-18.53 4.657 739.573 739.573 0 0 0-18.094 5c-2.474.716-3.813 1.125-3.813 1.125l-13.687 3.75c-.902.249-1.778.693-2.625 1.312-.288.21-.562.436-.844.688-1.1.98-2.15 2.27-3.156 3.844-.004.007.005.024 0 .03-.5.786-1.022 1.641-1.5 2.563-.004.008.004.024 0 .032a47.081 47.081 0 0 0-1.406 2.968c-.004.01.004.023 0 .032-3.667 8.51-6.62 21.13-8.937 36.219-.002.01.001.02 0 .03-.036.235-.059.484-.094.72a412.608 412.608 0 0 0-1.438 10.344c-.03.242-.063.475-.093.718a538.908 538.908 0 0 0-1.375 12.47v.03c-.214 2.129-.43 4.295-.625 6.47v.03c-.196 2.175-.384 4.35-.563 6.563v.031a810.337 810.337 0 0 0-.969 13.5v.031c-.872 13.684-1.46 27.79-1.78 41.562v.032c-.215 9.189-.313 18.213-.313 26.907 0 .967.027 1.963.03 2.937-.003.975-.03 1.97-.03 2.938 0 8.693.098 17.717.312 26.906v.03c.322 13.775.909 27.879 1.781 41.563v.031c.29 4.554.611 9.062.969 13.5v.031c.178 2.214.367 4.388.562 6.563v.03c.196 2.175.412 4.341.625 6.47v.03c.429 4.267.874 8.427 1.375 12.47.03.243.064.476.094.719.446 3.545.933 7.012 1.438 10.344.035.235.058.484.093.718.002.01-.001.022 0 .032 2.318 15.087 5.27 27.709 8.938 36.219.004.009-.004.022 0 .03a47.141 47.141 0 0 0 1.406 2.97c.004.008-.004.023 0 .03.478.923 1 1.779 1.5 2.563.005.007-.005.025 0 .032 1.005 1.573 2.057 2.864 3.156 3.843.282.252.556.477.844.688.847.62 1.723 1.064 2.625 1.312l13.687 3.75s1.339.41 3.812 1.125a737.896 737.896 0 0 0 18.094 5 911.514 911.514 0 0 0 18.531 4.657c3.432.824 7.003 1.655 10.72 2.5.01.002.02-.002.03 0a835.757 835.757 0 0 0 17.5 3.78c2.025.415 4.028.814 6.094 1.22.01.002.022-.002.032 0 4.123.81 8.34 1.618 12.594 2.375a638.93 638.93 0 0 0 12.937 2.156c4.343.68 8.69 1.327 13.062 1.906h.03c6.55.866 13.126 1.619 19.595 2.187 2.16.19 4.3.35 6.437.5 4.276.301 8.505.531 12.656.657 4.151.125 8.403.194 12.72.218 8.785.05 17.88-.117 27.25-.406 13.641-.42 27.846-1.135 42.374-2 19.604-1.167 39.798-2.592 60.124-3.875 15.024-.946 30.098-1.807 45.031-2.437.396-.017.792-.046 1.188-.063 7.393-.306 14.77-.551 22.062-.719 4.978-.114 9.931-.184 14.844-.218 2.456-.018 4.907-.037 7.343-.032l124.81.282-8.656 35.938 3.5 1.5c1.748.632 4.96.928 6.469.937a14.11 14.11 0 0 0 2.687-.25c.311-.058.624-.14.938-.219.304-.075.632-.156.937-.25a17.917 17.917 0 0 0 1.875-.687c1.822-.794 3.535-1.931 4.782-3.313l.03-.03a8.311 8.311 0 0 0 1.47-2.282l12.155-31.312 109.94.25c.747.374 1.477.745 2.22 1.094a93.427 93.427 0 0 0 8.843 3.625 92.16 92.16 0 0 0 4.375 1.406c5.1 1.508 10.188 2.552 15.344 3.25 2.946.4 5.926.694 8.937.906 1.506.106 3.034.18 4.563.25 3.057.14 6.138.213 9.312.25 6.347.074 12.979 0 20 0 10.41 0 20.322-.53 29.781-1.562 3.783-.413 7.491-.898 11.125-1.469a210.889 210.889 0 0 0 20.906-4.375c1.67-.439 3.336-.899 4.969-1.375a180.69 180.69 0 0 0 14.187-4.781c1.524-.585 3.042-1.16 4.53-1.781a164.843 164.843 0 0 0 8.72-3.938c1.418-.69 2.835-1.4 4.218-2.125a155.594 155.594 0 0 0 8.094-4.562 151.395 151.395 0 0 0 3.875-2.438c6.394-4.12 12.363-8.625 17.906-13.53 4.428-3.92 8.601-8.08 12.5-12.47.005-.006-.005-.025 0-.031.97-1.093 1.937-2.192 2.875-3.313.005-.006-.005-.025 0-.03.938-1.122 1.876-2.259 2.781-3.407.005-.006-.005-.025 0-.031a155.237 155.237 0 0 0 7.75-10.72c.005-.006-.005-.023 0-.03.809-1.229 1.629-2.465 2.406-3.72.005-.007-.005-.023 0-.03 2.34-3.778 4.567-7.653 6.625-11.656.004-.008-.004-.023 0-.032a177.11 177.11 0 0 0 2-4.03c.004-.009-.004-.024 0-.032.652-1.353 1.316-2.717 1.938-4.094.004-.009-.004-.022 0-.031a187.592 187.592 0 0 0 3.562-8.406c.004-.01-.004-.023 0-.031.56-1.423 1.095-2.868 1.625-4.313.003-.009-.003-.022 0-.031a203.141 203.141 0 0 0 3.031-8.813c.003-.009-.003-.022 0-.03.47-1.49.935-2.991 1.375-4.5.003-.01-.003-.022 0-.032.44-1.51.87-3.032 1.281-4.562.003-.01-.003-.022 0-.032a235.737 235.737 0 0 0 3.344-14.094v-.03c.324-1.59.611-3.205.907-4.813v-.032c2.074-11.318 3.462-23.062 4.156-35.219v-.03c.098-1.729.178-3.476.25-5.22v-.03c.142-3.498.246-7.008.28-10.563v-.031c.018-1.783.01-3.578 0-5.375 0-.636-.021-1.271-.03-1.906.01-.635.03-1.27.03-1.906.01-1.797.018-3.592 0-5.375v-.032a337.906 337.906 0 0 0-.28-10.562v-.03c-.071-1.744-.152-3.492-.25-5.22v-.03c-.694-12.158-2.082-23.9-4.156-35.22v-.031c-.296-1.608-.583-3.223-.907-4.812v-.032a235.883 235.883 0 0 0-3.344-14.094c-.003-.01.003-.021 0-.03-.41-1.531-.84-3.054-1.28-4.563-.004-.01.002-.022 0-.032-.441-1.51-.906-3.011-1.376-4.5-.003-.009.003-.022 0-.03-.47-1.49-.968-2.971-1.468-4.438-.5-1.467-1.033-2.93-1.563-4.375-.003-.01.003-.023 0-.032a197.25 197.25 0 0 0-1.625-4.312c-.004-.009.004-.022 0-.031a187.377 187.377 0 0 0-3.562-8.406c-.004-.008.004-.023 0-.032-.622-1.376-1.286-2.74-1.938-4.093-.004-.008.004-.024 0-.032a176.408 176.408 0 0 0-2-4.03c-.004-.009.004-.024 0-.032-2.058-4.004-4.284-7.878-6.625-11.656-.005-.007.005-.023 0-.031-.777-1.255-1.597-2.49-2.406-3.719-.005-.007.005-.024 0-.031-2.437-3.7-5.024-7.26-7.75-10.72-.005-.005.005-.025 0-.03a152.01 152.01 0 0 0-2.781-3.407c-.005-.006.005-.025 0-.03-.938-1.122-1.905-2.22-2.875-3.313-.005-.006.005-.026 0-.032a147.136 147.136 0 0 0-12.5-12.469c-5.543-4.905-11.512-9.41-17.906-13.53a151.479 151.479 0 0 0-3.875-2.438 155.594 155.594 0 0 0-8.094-4.563c-1.383-.724-2.8-1.434-4.219-2.125a164.798 164.798 0 0 0-8.718-3.937c-1.49-.62-3.007-1.196-4.531-1.781a180.747 180.747 0 0 0-14.187-4.781c-1.633-.477-3.3-.936-4.969-1.375a210.847 210.847 0 0 0-20.906-4.375 237.29 237.29 0 0 0-11.125-1.47c-9.459-1.032-19.371-1.563-29.781-1.563-7.02 0-13.652-.074-20 0-3.174.037-6.255.11-9.312.25-1.529.07-3.057.144-4.563.25a139.71 139.71 0 0 0-8.937.906c-5.156.699-10.244 1.743-15.344 3.25-1.457.431-2.913.894-4.375 1.406a93.405 93.405 0 0 0-8.844 3.625c-.742.35-1.472.72-2.219 1.094l-109.94.25-12.156-31.312a8.311 8.311 0 0 0-1.468-2.281c-.01-.01-.022-.02-.031-.031-1.247-1.381-2.96-2.52-4.782-3.313a17.908 17.908 0 0 0-1.875-.687c-.305-.093-.633-.175-.937-.25-.314-.078-.627-.16-.938-.219a14.11 14.11 0 0 0-2.687-.25z"
      style={{
        fillOpacity: 0.99607999,
        stroke: "#191919",
        strokeWidth: 14,
      }}
      transform="translate(-52.937 -486.69)"
    />
    <path
      d="M610.52 493.69c-1.509.009-4.721.306-6.469.938l-3.5 1.5 8.656 35.844-124.81.28c-77.962.166-166.52-11.503-232.93-9.5-66.412 2.004-152.12 28-152.12 28l-13.687 3.782c-19.25 5.296-25.718 97.367-25.718 166.78 0 1.113.027 2.253.032 3.375-.005 1.122-.032 2.262-.032 3.375 0 69.414 6.468 161.48 25.718 166.78l13.687 3.781s85.711 25.996 152.12 28c66.412 2.004 154.97-9.665 232.93-9.5l124.81.281-8.656 35.844 3.5 1.5c1.748.632 4.96.929 6.469.938.849.005 1.755-.074 2.688-.25.31-.058.623-.141.937-.219.305-.075.633-.157.937-.25a17.946 17.946 0 0 0 1.875-.687c1.822-.792 3.535-1.903 4.782-3.282l.03-.03a8.316 8.316 0 0 0 1.47-2.282l12.156-31.25 109.94.25c23.9 11.942 45.51 10.719 73.593 10.719 133.25 0 187.63-86.586 187-201.38 0-.78-.02-1.566-.031-2.344.012-.778.03-1.563.03-2.344.629-114.79-53.748-201.38-187-201.38-28.081 0-49.692-1.223-73.592 10.72l-109.94.25-12.156-31.25a8.316 8.316 0 0 0-1.47-2.282l-.03-.03c-1.247-1.38-2.96-2.49-4.782-3.282a17.94 17.94 0 0 0-1.875-.688 18.437 18.437 0 0 0-.937-.25c-.314-.077-.627-.16-.937-.218a14.135 14.135 0 0 0-2.688-.25z"
      style={{
        fill: "var(--primary-color)",
        fillOpacity: 0.99607999,
      }}
      transform="translate(-52.937 -486.69)"
    />
    <path
      d="M400.34 855.24c-33.364 0-65.307 1.8-94.811 5.063 25.66 48.714 97.985 30.265 205.56 31.53 49.686.585 89.543 1.88 121.53 2.375-47.16-23.334-133.53-38.969-232.28-38.969z"
      style={{
        opacity: 0.9,
        fill: "#262626",
        fillOpacity: 0.99607999,
      }}
      transform="translate(-52.937 -486.69)"
    />
    <path
      d="M400.34 855.24c-3.206 0-6.383.03-9.562.063.818 16.17 6.428 30.257 14.594 38.844 4.671-.076 9.495-.197 14.437-.344-8.566-8.193-14.593-22.228-15.72-38.562-1.25-.005-2.494 0-3.75 0z"
      style={{
        opacity: 0.5,
        fillOpacity: 0.99607999,
      }}
      transform="translate(-52.937 -486.69)"
    />
    <path
      d="m989.02 827.5-5.094.594c-21.545 2.512-37.688 25.979-39.28 54.53l-.376 7.126 5.25-4.844c15.89-14.68 28.303-32.507 37.406-52.75l2.09-4.65z"
      style={{
        textIndent: 0,
        textTransform: "none",
        blockProgression: "tb",
        color: "#000",
        fill: "#212121",
        stroke: "#191919",
        strokeWidth: 5,
      }}
      transform="translate(-52.937 -486.69)"
    />
    <path
      d="M783.47 838.5s79.677-22.596 105.38-31.982c26.839-9.802 98.859-39.146 98.859-39.146s-8.74 42.47-30.483 57.918c-77.23 54.87-232.69 53.85-232.69 53.85"
      style={{
        opacity: 0.5,
        fill: "none",
        stroke: "#292929",
        strokeWidth: 6,
        strokeLinecap: "round",
        strokeLinejoin: "round",
      }}
      transform="translate(-52.937 -486.69)"
    />
    <path
      d="m869.97 817.84-4.437 2.344c.989 1.157 1.795 2.428 2.375 3.844 4.797 11.717-10.736 29.236-26.875 35.78-.517.21-1.813.841-3.407 1.657l13.625-3.875c17.306-8.458 27.47-23.082 23-34-.916-2.238-2.375-4.166-4.28-5.75z"
      style={{
        fill: "url(#SimpleGreenCarTopView_svg__b)",
      }}
      transform="translate(-52.937 -486.69)"
    />
    <path
      d="m878.55 813.38-4.437 2.344c.989 1.157 1.795 2.428 2.374 3.844 4.798 11.717-10.736 29.236-26.875 35.78-.516.21-1.812.841-3.406 1.657l13.625-3.875c17.306-8.458 27.47-23.082 23-34-.916-2.238-2.375-4.166-4.28-5.75z"
      style={{
        fill: "url(#SimpleGreenCarTopView_svg__c)",
      }}
      transform="translate(-52.937 -486.69)"
    />
    <path
      d="m884.74 811.96-4.437 2.344c.989 1.157 1.795 2.428 2.375 3.844 4.797 11.717-10.736 29.236-26.875 35.78-.517.21-1.813.841-3.407 1.657l13.625-3.875c17.306-8.458 27.47-23.082 23-34-.916-2.238-2.375-4.166-4.28-5.75z"
      style={{
        fill: "url(#SimpleGreenCarTopView_svg__d)",
      }}
      transform="translate(-52.937 -486.69)"
    />
    <path
      d="m901.65 807.69-6.187 1.844c.96 1.713 1.654 3.532 2.03 5.469 3.12 16.034-20.961 34.284-43.03 38.5-3.395.648-28.884 8.576-32.158 8.804v4.125l41.439-12.148c26.285-5.496 44.949-22.448 41.875-38.25-.596-3.062-1.956-5.86-3.969-8.344z"
      style={{
        fill: "url(#SimpleGreenCarTopView_svg__e)",
      }}
      transform="translate(-52.937 -486.69)"
    />
    <path
      d="m901.65 807.69-6.187 1.844c.96 1.713 1.654 3.532 2.03 5.469 3.12 16.034-20.961 34.284-43.03 38.5-3.395.648-28.884 8.576-32.158 8.804v4.125l41.439-12.148c26.285-5.496 44.949-22.448 41.875-38.25-.596-3.062-1.956-5.86-3.969-8.344z"
      style={{
        fill: "url(#SimpleGreenCarTopView_svg__f)",
      }}
      transform="translate(-52.937 -486.69)"
    />
    <path
      d="m857.12 822.46-3.964 2.094a12.633 12.633 0 0 1 2.122 3.433c4.286 10.467-9.591 26.117-24.009 31.964-.461.188-1.619.751-3.042 1.48l12.17-3.462c15.46-7.555 24.54-20.62 20.547-30.373-.819-1.998-2.122-3.721-3.825-5.136z"
      style={{
        fill: "url(#SimpleGreenCarTopView_svg__g)",
      }}
      transform="translate(-52.937 -486.69)"
    />
    <path
      d="m843.32 826.03-3.964 2.094a12.633 12.633 0 0 1 2.122 3.433c4.286 10.467-9.591 26.117-24.008 31.964-.462.188-1.62.751-3.043 1.48l12.17-3.462c15.46-7.555 24.54-20.62 20.547-30.373-.819-1.998-2.122-3.721-3.825-5.136z"
      style={{
        fill: "url(#SimpleGreenCarTopView_svg__h)",
      }}
      transform="translate(-52.937 -486.69)"
    />
    <path
      d="M233.27 845.72c8.293-2.023 15.486-1.479 19.797 5.787l-2.493 17.897c-6.876 6.173-13.75 4.951-20.625.156z"
      style={{
        fill: "url(#SimpleGreenCarTopView_svg__i)",
      }}
      transform="translate(-52.937 -486.69)"
    />
    <path
      d="M253.54 848.99c8.15-1.21 15.167-.573 18.843 5.508l-2.373 17.034c-6.484 2.975-12.983 5.21-19.631.148z"
      style={{
        fill: "url(#SimpleGreenCarTopView_svg__j)",
      }}
      transform="translate(-52.937 -486.69)"
    />
    <path
      d="M400.34 852.75c-33.454 0-65.492 1.79-95.093 5.063l-3.656.406 1.718 3.25c6.672 12.664 16.562 21.113 29.062 26.438 12.501 5.324 27.572 7.612 45.093 8.437 35.042 1.65 79.954-2.631 133.59-2 49.66.585 89.508 1.879 121.53 2.375l1.125-4.75c-47.84-23.68-134.34-39.22-233.36-39.22zm0 5c91.169 0 171.75 13.479 220.09 33.719-29.952-.582-65.212-1.606-109.31-2.125-53.937-.635-98.976 3.652-133.4 2.031-17.214-.81-31.767-3.105-43.406-8.062-10.453-4.452-18.485-11.154-24.5-20.906 28.307-2.983 58.735-4.656 90.53-4.656z"
      style={{
        textIndent: 0,
        textTransform: "none",
        blockProgression: "tb",
        opacity: 0.9,
        color: "#000",
        fill: "#191919",
      }}
      transform="translate(-52.937 -486.69)"
    />
    <path
      d="m260.5 607.38-77.749 12.469c-27.15 4.354-48.947 48.773-50.999 104.84 2.052 56.071 23.849 100.49 50.999 104.84l77.749 12.469c13.296 0 24-10.704 24-24v-186.62c0-13.296-10.704-24-24-24zM691.96 573.16c-2.97 0-5.893.332-8.781.969l-.031-.031-63.843 12.312c-17.728 6.604-32 14.272-32 32v212.56c0 17.728 14.272 25.395 32 32l63.843 12.312.03-.032c2.889.637 5.813.97 8.782.97 45.395 0 82.198-57.364 82.312-151.53-.114-94.17-36.916-151.53-82.312-151.53z"
      style={{
        opacity: 0.9,
        fill: "#262626",
        fillOpacity: 0.99607999,
        stroke: "#191919",
        strokeWidth: 5,
      }}
      transform="translate(-52.937 -486.69)"
    />
    <path
      d="M400.34 594.15c-33.364 0-65.307-1.8-94.811-5.062 25.66-48.714 97.985-30.265 205.56-31.531 49.686-.585 89.543-1.88 121.53-2.375-47.16 23.334-133.53 38.969-232.28 38.969z"
      style={{
        opacity: 0.9,
        fill: "#262626",
        fillOpacity: 0.99607999,
      }}
      transform="translate(-52.937 -486.69)"
    />
    <path
      d="M400.34 594.15c-3.206 0-6.383-.03-9.562-.062.818-16.171 6.428-30.257 14.594-38.844 4.671.075 9.495.196 14.437.343-8.566 8.193-14.593 22.228-15.72 38.562-1.25.005-2.494 0-3.75 0z"
      style={{
        opacity: 0.5,
        fillOpacity: 0.99607999,
      }}
      transform="translate(-52.937 -486.69)"
    />
    <path
      d="m989.02 621.89-5.094-.594c-21.545-2.512-37.688-25.979-39.28-54.53l-.376-7.126 5.25 4.844c15.89 14.68 28.303 32.507 37.406 52.75z"
      style={{
        textIndent: 0,
        textTransform: "none",
        blockProgression: "tb",
        color: "#000",
        fill: "#212121",
        stroke: "#191919",
        strokeWidth: 5,
      }}
      transform="translate(-52.937 -486.69)"
    />
    <path
      d="M783.47 610.89s79.677 22.596 105.38 31.982c26.839 9.802 98.859 39.146 98.859 39.146s-8.74-42.47-30.483-57.918c-77.23-54.87-232.69-53.86-232.69-53.86"
      style={{
        opacity: 0.5,
        fill: "none",
        stroke: "#292929",
        strokeWidth: 6,
        strokeLinecap: "round",
        strokeLinejoin: "round",
      }}
      transform="translate(-52.937 -486.69)"
    />
    <path
      d="m869.97 631.55-4.437-2.344c.989-1.157 1.795-2.428 2.375-3.844 4.797-11.717-10.736-29.236-26.875-35.78-.517-.21-1.813-.841-3.407-1.657l13.625 3.875c17.306 8.458 27.47 23.082 23 34-.916 2.238-2.375 4.166-4.28 5.75z"
      style={{
        fill: "url(#SimpleGreenCarTopView_svg__k)",
      }}
      transform="translate(-52.937 -486.69)"
    />
    <path
      d="m878.55 636.01-4.437-2.344c.989-1.157 1.795-2.428 2.374-3.844 4.798-11.717-10.736-29.236-26.875-35.78-.516-.21-1.812-.841-3.406-1.657l13.625 3.875c17.306 8.458 27.47 23.082 23 34-.916 2.238-2.375 4.166-4.28 5.75z"
      style={{
        fill: "url(#SimpleGreenCarTopView_svg__l)",
      }}
      transform="translate(-52.937 -486.69)"
    />
    <path
      d="m884.74 637.42-4.437-2.344c.989-1.157 1.795-2.428 2.375-3.844 4.797-11.717-10.736-29.236-26.875-35.78-.517-.21-1.813-.841-3.407-1.657l13.625 3.875c17.306 8.458 27.47 23.082 23 34-.916 2.238-2.375 4.166-4.28 5.75z"
      style={{
        fill: "url(#SimpleGreenCarTopView_svg__m)",
      }}
      transform="translate(-52.937 -486.69)"
    />
    <path
      d="m901.65 641.7-6.187-1.844c.96-1.713 1.654-3.532 2.03-5.469 3.12-16.034-20.961-34.284-43.03-38.5-3.395-.648-28.884-8.576-32.158-8.804v-4.125l41.439 12.148c26.285 5.496 44.949 22.448 41.875 38.25-.596 3.062-1.956 5.86-3.969 8.344z"
      style={{
        fill: "url(#SimpleGreenCarTopView_svg__n)",
      }}
      transform="translate(-52.937 -486.69)"
    />
    <path
      d="m901.65 641.7-6.187-1.844c.96-1.713 1.654-3.532 2.03-5.469 3.12-16.034-20.961-34.284-43.03-38.5-3.395-.648-28.884-8.576-32.158-8.804v-4.125l41.439 12.148c26.285 5.496 44.949 22.448 41.875 38.25-.596 3.062-1.956 5.86-3.969 8.344z"
      style={{
        fill: "url(#SimpleGreenCarTopView_svg__o)",
      }}
      transform="translate(-52.937 -486.69)"
    />
    <path
      d="m857.12 626.93-3.964-2.094a12.633 12.633 0 0 0 2.122-3.433c4.286-10.467-9.591-26.117-24.009-31.964-.461-.188-1.619-.751-3.042-1.48l12.17 3.462c15.46 7.555 24.54 20.62 20.547 30.373-.819 1.998-2.122 3.721-3.825 5.136z"
      style={{
        fill: "url(#SimpleGreenCarTopView_svg__p)",
      }}
      transform="translate(-52.937 -486.69)"
    />
    <path
      d="m843.32 623.36-3.964-2.094a12.633 12.633 0 0 0 2.122-3.433c4.286-10.467-9.591-26.117-24.008-31.964-.462-.188-1.62-.751-3.043-1.48l12.17 3.462c15.46 7.555 24.54 20.62 20.547 30.373-.819 1.998-2.122 3.721-3.825 5.136z"
      style={{
        fill: "url(#SimpleGreenCarTopView_svg__q)",
      }}
      transform="translate(-52.937 -486.69)"
    />
    <path
      d="M233.27 603.66c8.293 2.023 15.486 1.479 19.797-5.787l-2.493-17.897c-6.876-6.173-13.75-4.951-20.625-.156z"
      style={{
        fill: "url(#SimpleGreenCarTopView_svg__r)",
      }}
      transform="translate(-52.937 -486.69)"
    />
    <path
      d="M253.54 600.4c8.15 1.21 15.167.573 18.843-5.508l-2.373-17.034c-6.484-2.975-12.983-5.21-19.631-.148z"
      style={{
        fill: "url(#SimpleGreenCarTopView_svg__s)",
      }}
      transform="translate(-52.937 -486.69)"
    />
    <path
      d="M400.34 596.64c-33.454 0-65.492-1.79-95.093-5.062l-3.656-.407 1.718-3.25c6.672-12.664 16.562-21.113 29.062-26.438 12.501-5.324 27.572-7.612 45.093-8.437 35.042-1.65 79.954 2.63 133.59 2 49.66-.585 89.508-1.879 121.53-2.375l1.125 4.75c-47.849 23.675-134.36 39.219-233.37 39.219zm0-5c91.169 0 171.75-13.479 220.09-33.719-29.952.582-65.212 1.606-109.31 2.125-53.937.635-98.976-3.652-133.4-2.031-17.214.81-31.767 3.105-43.406 8.062-10.453 4.452-18.485 11.154-24.5 20.906 28.307 2.983 58.735 4.656 90.53 4.656z"
      style={{
        textIndent: 0,
        textTransform: "none",
        blockProgression: "tb",
        opacity: 0.9,
        color: "#000",
        fill: "#191919",
      }}
      transform="translate(-52.937 -486.69)"
    />
  </svg>
);
export default SvgSimpleGreenCarTopView;
